export default IconSchema => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-schema" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 2h5v4h-5z" />
  <path d="M15 10h5v4h-5z" />
  <path d="M5 18h5v4h-5z" />
  <path d="M5 10h5v4h-5z" />
  <path d="M10 12h5" />
  <path d="M7.5 6v4" />
  <path d="M7.5 14v4" />
</svg>`;